'use strict';

exports.__esModule = true;
exports.SankeyDefaultProps = exports.SankeyPropTypes = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _props = require('../../../props');

var _noop = require('../../../lib/noop');

var _noop2 = _interopRequireDefault(_noop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SankeyPropTypes = exports.SankeyPropTypes = {
    data: _propTypes2.default.shape({
        nodes: _propTypes2.default.arrayOf(_propTypes2.default.shape({
            id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired
        })).isRequired,
        links: _propTypes2.default.arrayOf(_propTypes2.default.shape({
            source: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
            target: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired
        })).isRequired
    }).isRequired,

    align: _props.sankeyAlignmentPropType.isRequired,

    // nodes
    nodeOpacity: _propTypes2.default.number.isRequired,
    nodeHoverOpacity: _propTypes2.default.number.isRequired,
    nodeHoverOthersOpacity: _propTypes2.default.number.isRequired,
    nodeWidth: _propTypes2.default.number.isRequired,
    nodePaddingX: _propTypes2.default.number.isRequired,
    nodePaddingY: _propTypes2.default.number.isRequired,
    nodeBorderWidth: _propTypes2.default.number.isRequired,
    nodeBorderColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),

    // links
    linkOpacity: _propTypes2.default.number.isRequired,
    linkHoverOpacity: _propTypes2.default.number.isRequired,
    linkHoverOthersOpacity: _propTypes2.default.number.isRequired,
    linkContract: _propTypes2.default.number.isRequired,

    // labels
    enableLabels: _propTypes2.default.bool.isRequired,
    labelPosition: _propTypes2.default.oneOf(['inside', 'outside']).isRequired,
    labelPadding: _propTypes2.default.number.isRequired,
    labelOrientation: _propTypes2.default.oneOf(['horizontal', 'vertical']).isRequired,
    labelTextColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    getLabelTextColor: _propTypes2.default.func.isRequired, // computed
    label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
    labelFormat: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    getLabel: _propTypes2.default.func.isRequired, // computed

    // tooltip
    nodeTooltip: _propTypes2.default.func,
    linkTooltip: _propTypes2.default.func,

    // interactivity
    isInteractive: _propTypes2.default.bool.isRequired,
    onClick: _propTypes2.default.func.isRequired,
    tooltipFormat: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string])
}; /*
    * This file is part of the nivo project.
    *
    * Copyright 2016-present, Raphaël Benitte.
    *
    * For the full copyright and license information, please view the LICENSE
    * file that was distributed with this source code.
    */
var SankeyDefaultProps = exports.SankeyDefaultProps = {
    align: 'center',

    // nodes
    nodeOpacity: 0.75,
    nodeHoverOpacity: 1,
    nodeHoverOthersOpacity: 0.15,
    nodeWidth: 12,
    nodePaddingX: 0,
    nodePaddingY: 12,
    nodeBorderWidth: 1,
    nodeBorderColor: 'inherit:darker(0.5)',

    // links
    linkOpacity: 0.25,
    linkHoverOpacity: 0.6,
    linkHoverOthersOpacity: 0.15,
    linkContract: 0,

    // labels
    enableLabels: true,
    label: 'id',
    labelPosition: 'inside',
    labelPadding: 9,
    labelOrientation: 'horizontal',
    labelTextColor: 'inherit:darker(0.8)',

    // interactivity
    isInteractive: true,
    onClick: _noop2.default
};


//////////////////
// WEBPACK FOOTER
// ./~/nivo/lib/components/charts/sankey/props.js
// module id = 306
// module chunks = 0